import { takeLatest } from "redux-saga/effects";
import { postSetPasswordRequestSaga } from "./saga";
import { POST_SET_PASSWORD_REQUEST } from "../consts";

export default function* watchSetPassword() {
  yield takeLatest(POST_SET_PASSWORD_REQUEST, postSetPasswordRequestSaga);
}
